import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      "fill-rule": "evenodd",
      d: "M5.434 5.434a.8.8 0 0 1 1.132 0l12 12a.8.8 0 1 1-1.132 1.132l-12-12a.8.8 0 0 1 0-1.132",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#fff",
      "fill-rule": "evenodd",
      d: "M18.566 5.434a.8.8 0 0 1 0 1.132l-12 12a.8.8 0 1 1-1.132-1.132l12-12a.8.8 0 0 1 1.132 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }